/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {
  context
} from '../../../objects/context.js';
import ko from 'knockout';
import 'knockout.validation';
import $ from 'jquery';

import optionsUtil from '../../../objects/optionsUtil.js';
import userObj from '../../../objects/userObj.js';

class loginModel {

  constructor(params) {
    // Profile
    this.componentName = ko.observable("footer");
    this.context = context;
    this.id = this.context.util.guid();
    this.visible = ko.observable(true);

    this.componentTitle = ko.observable("User Infromation");
    this.componentMessage = ko.observable("");

    this.user = ko.observable({});

    this.formMode = "";
    this.broadcastUpdate = false;

    this.password = ko.observable("").extend({
      minLength: {
        params: 6,
        message: 'Minimum length is 6 characters'
      },
      required: {
        params: true,
        message: 'Password is required'
      }
    });
    this.password2 = ko.observable("").extend({
      minLength: {
        params: 6,
        message: 'Minimum length is 6 characters'
      },
      required: {
        params: true,
        message: 'Password is required'
      },
      equal: {
        params: this.password,
        message: 'Passwords must be equal'
      }
    });

    //Vivible Obs
    this.passwordVisible = ko.observable(false);

    //Enable Buttons
    this.updateEnable = ko.observable(false);

    this.isValidPassword = ko.validatedObservable({
      password: this.password,
      password2: this.password2
    });

    this.context.eventManager.subscribe((userFormObj) => {
      this.handleUpdateUser(userFormObj);
    }, this, "updateUser");

  }

  handleUpdateUser(userFormObj) {
    console.log("show User Modal");
    console.log(userFormObj);
    this.getUserData();

    this.formMode = userFormObj.formMode;
    this.broadcastUpdate = userFormObj.broadcastUpdate;

    $('#UserModal').modal('show');
  }

  hideAll() {

    this.passwordVisible(false);
  }

  getUserData() {

    let self = this;

    let optionsUtilObj = new optionsUtil(this.context);
    optionsUtilObj.getUser().then(response => {
      self.user(new userObj(response));
      console.log(self.user());
      self.validateUser();
    });
  }

  validateUser() {
    this.hideAll();

    //Check password:
    if (this.user().password().length <= 3) {
      this.passwordVisible(true);
      this.componentTitle("Update your password");
      this.componentMessage("Either, this is the first time you have logged in or it's time to update your password!");

    }
  }

  validateForm() {

    console.log("login:validateForm: password: %o  password2: %o", this.password, this.password2);

    if (this.formMode === "Password Update") {
      let errors = ko.validation.group([this.password(), this.password2()]);
      console.log('login:validateForm: errors: %o', errors);

      if (errors().length === 0) {
        this.updateEnable(true);
      } else {
        this.updateEnable(false);
      }

    }

  }


  update() {

    let self = this;
    let optionsUtilObj = new optionsUtil(this.context);

    switch (this.formMode) {
      case "Password Update":
        optionsUtilObj.updatePassword(this.user, this.password).then(response => {
          if (self.broadcastUpdate) {
            $('#UserModal').modal('hide');
            self.context.loginStatusObj().UserValid = true;
            self.context.loginStatusObj.valueHasMutated();
          }

        }).catch((response) => {
          console.log('login:update: response: %o', response);
          this.context.Raven.captureMessage('login:update: Password Update Error:');
        });

        break;

      case "Login":

        optionsUtilObj.updatePassword(this.user, this.password).then(response => {
          if (self.broadcastUpdate) {
            $('#UserModal').modal('hide');
            self.context.loginStatusObj().UserValid = true;
            self.context.loginStatusObj.valueHasMutated();
          }
        });

        break;
    }
  }
}

export default {
  viewModel: loginModel,
  template: require('!raw-loader!./login.html')
};


// WEBPACK FOOTER //
// ./src/components/user/login/login.js